import { classNames } from '@dimjs/utils';
import { CSSProperties, forwardRef, ReactElement, ReactNode, useImperativeHandle, useRef } from 'react';
import { useEffectCustom } from '../hooks';
import { NativeInfiniteScroll, NativeInfiniteScrollProps } from '../native-infinite-scroll';
import {
  NativePullToRefresh,
  NativePullToRefreshProps,
  NativePullToRefreshRefApi,
} from '../native-pull-to-refresh';
import { NativeScroll } from '../native-scroll';
import { px2DPIpx } from '../utils/pxrem';
import './style.less';

export type NativeListViewProps = {
  height?: number | string;
  infiniteScrollProps: NativeInfiniteScrollProps;
  pullToRefreshProps: NativePullToRefreshProps;
  className?: string;
  style?: CSSProperties;
  onInitialize?: () => void;
  children?: ReactNode | ReactNode[];
  empty?: ReactElement;
  loading?: ReactElement;
};

export type NativeListViewRefApi = {
  scrollToTop: () => void;
};

export const NativeListView = forwardRef<NativeListViewRefApi, NativeListViewProps>((props, ref) => {
  const height = (typeof props.height === 'number' ? px2DPIpx(props.height) : props.height) || '100%';

  const nativePullToRefreshRef = useRef<NativePullToRefreshRefApi>(null);

  useEffectCustom(() => {
    props.onInitialize?.();
  }, []);

  useImperativeHandle(ref, () => {
    return {
      scrollToTop: () => {
        nativePullToRefreshRef.current?.scrollToTop();
      },
    };
  });

  return (
    <NativeScroll
      className={classNames('v-native-list-view', props.className)}
      style={{ height, ...props.style }}
    >
      {props.empty ? <div className="v-native-list-view-empty">{props.empty}</div> : null}
      {props.loading ? <div className="v-native-list-view-loading">{props.loading}</div> : null}
      <NativePullToRefresh {...props.pullToRefreshProps} ref={nativePullToRefreshRef}>
        {props.children}
        <NativeInfiniteScroll {...props.infiniteScrollProps} />
      </NativePullToRefresh>
    </NativeScroll>
  );
});
